import { render, staticRenderFns } from "./Capture.vue?vue&type=template&id=a9b0a54e&"
import script from "./Capture.vue?vue&type=script&lang=js&"
export * from "./Capture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports